import React from "react";
import PageLayout from "@layout/pageLayout";
import Content from "@searchComponents/Content";

function SearchPage() {
    return (
        <PageLayout>
            <Content/>
        </PageLayout>

    );
}

export default SearchPage;
